module.exports = __webpack_public_path__ + "assets/snow.1ae8cdc0.svg";